class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.suggestions = this.closest(".search-drawer, .search-drawer-page").querySelectorAll("[search-suggestions]");

        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    tabShow(){
      this.headerItems = this.querySelectorAll('#predictive-search-results .search-tab');
      this.collections = this.querySelectorAll('#predictive-search-results .search-tab-content');
      console.log(this.headerItems, this.collections);
      if (this.collections.length > 0) {
          this.collections[0].classList.add('active');
      }

      this.headerItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          const target = item.dataset.item;
    
          this.headerItems.forEach(item => {
            item.classList.remove('selected');
          });
    
          if(this.headerItems.length > 1){
            item.classList.add('selected');
          }
    
          this.collections.forEach(collection => {
            if (collection.dataset.item === target) {
              collection.classList.add('active');
              setTimeout(() => {
                collection.style.opacity = 1;
              }, 10);
            } else {
              collection.classList.remove('active');
              collection.style.opacity = 0;
            }
          });
        });
        if (index === 0 && this.headerItems.length > 1) {
          item.classList.add('selected');
        }
      });
    }
    atcSearch(){
      this.atcBtns = document.querySelectorAll(".atc-btn-1");
      this.atcBtns.forEach((item) => {
        item.addEventListener("click", (e)=>{
          e.preventDefault();
        })
      })
    }
    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
                this.tabShow();
                // this.atcSearch();
            })
            .catch((error) => {
                this.close();
                throw error;
            })
            .finally(()=>{
              customFormSubmit();
            })
            
    }
    
    open() {
        this.suggestions.forEach((item) => {
          item.style.display = "none";
        });
    }

    close() {
        this.predictiveSearchResults.innerHTML = '';
        this.suggestions.forEach((item) => {
          item.style.display = "block";
        });
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
